import { ErrorResponseInterface } from './error-response.interface';

export function handleErrorResponse(error): ErrorResponseInterface {
  return {
    status: error.status,
    message: error.message || 'An error occurred',
    errorData: error.errorData
  };
}